import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FAuthPasswordForgot from '../features/password-forgot/FAuthPasswordForgot';
import langAuthPasswordForgot from '../features/password-forgot/langs/langAuthPasswordForgot';

const PAuthPasswordForgot = () => {
	const { t } = useTranslation();

	return (
		<Grid container spacing={3} alignItems="center" justifyContent="center">
			<Grid item sm={6} className="flex items-center">
				<Paper variant="elevation" style={{ padding: '36px', textAlign: 'center' }}>
					<Typography
						variant="h1"
						component="h1"
						style={{ fontWeight: 600, fontSize: '1.5rem', marginBottom: '24px' }}
					>
						{t(langAuthPasswordForgot.title_forgot_password.tag)}
					</Typography>
					<FAuthPasswordForgot />
				</Paper>
			</Grid>
		</Grid>
	);
};

export default PAuthPasswordForgot;
